module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/~/algoliasearch/src/clone.js
// module id = 83
// module chunks = 114276838955818